import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Moment from "moment";
import "./Craft.css";

import { get } from "../../../utils/BeeApi";

import Header from "../../App/Header/Header";
import Footer from "../../App/Footer/Footer";
import Loader from "../../Loader/Loader";

import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import ContentArticle from "../ContentArticle/ContentArticle";
import ContentExternal from "../ContentExternal/ContentExternal";
import ContentEvent from "../ContentEvent/ContentEvent";
import CraftSummaryList from "./CraftSummaryList/CraftSummaryList";

class Craft extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.subscribedPromises = [];
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.fetchContent();
    }
  }

  componentDidMount() {
    this.fetchContent();
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function(promise) {
      promise.cancel();
    });
  }

  fetchContent() {
    this.setState({
      error: "",
      isLoading: true
    });

    const contentId = this.props.match.params.id;

    const createPromise = get("contents/" + contentId, {});
    createPromise.promise
      .then(response => {
        this.setState({
          content: response.data,
          error: "",
          isLoading: false,
          // Categories that have the Craft group
          categories: response.data.categories.filter((category, index) => {
            let groupIds = category.groups.map((group, index) => {
              return group.groupId;
            });
            return groupIds.includes("5f84ad6d46900");
          })
        });
      })
      .catch(error => {
        !error.isCanceled &&
          this.setState({
            error: error,
            content: {},
            isLoading: false
          });
      });
  }

  render() {
    const { user } = this.props;
    const { content } = this.state;

    return (
      <div className="Main">
        <Header user={user} title={content ? content.title : "Writing Craft"} />
        <Grid className="MainContent">
          <Row className="mt-sm mb-sm">
            <Col xs={12} md={8} className="Content">
              <div className="card card-emphasis  mt-md mb-md">
                {this.renderContent()}
              </div>
            </Col>
            <Col xs={12} md={4}>
              {this.renderRelatedContent()}
            </Col>
          </Row>
        </Grid>
        <Footer />
      </div>
    );
  }

  renderContent() {
    const { content, isLoading, error } = this.state;
    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;

    return content ? (
      <div>
        {content.typeId === 1 && <ContentArticle {...content} />}
        {content.typeId === 2 && <ContentEvent {...content} />}
        {content.typeId === 4 && <ContentExternal {...content} />}
      </div>
    ) : (
      <div />
    );
  }

  renderRelatedContent() {
    const { categories, error, isLoading } = this.state;

    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    const categoryIds =
      categories && categories.length > 0
        ? categories.map(category => category.categoryId)
        : "";

    return categories && categories.length > 0 ? (
      <div className="card card-warning  mt-md mb-md">
        <h3 className="text-uppercase">Writing Craft</h3>
        <hr />
        <CraftSummaryList
          rank={Moment().format("YYYY-MM-DD HH:mm:ss")}
          category={categoryIds}
          operand="or"
          limit={10}
        />
        <hr />
        <Link className="hyperlink-1 text-capitalize" to={"/writing-craft"}>
          {`More Writing Craft`}
          <i className="material-icons md-18">arrow_forward</i>
        </Link>
      </div>
    ) : (
      <div />
    );
  }
}

export default Craft;
